import React from 'react';
import { useTranslator } from 'tradera/lang/translate';
import { GtmService } from 'tradera/services/google-tagmanager-service';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import WarningIcon from '@tradera/blueprint/theme/icons/warning.svg?jsx';
import { Button } from '../atoms/button/button';

const trackPaymentOnboarding = (action, label) => {
    GtmService.trackAction('Tradera Payment Onboarding', action, label);
};

const InvoiceUnpaidAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert d-flex mx-2 text-hyphenate">
            {t('siteheader_invoiceUnpaidDescription')}
        </div>
    );
};

const InvoiceOverdueAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex mx-2 my-1 text-hyphenate">
            <WarningIcon className="icon mr-2 flex-shrink-0" />
            <span>
                <strong>{t('siteheader_invoiceOverdueTitle')}</strong>
                <br />
                {t('siteheader_invoiceOverdueDescription')}
            </span>
        </div>
    );
};

const BankAccountMissingAlert = () => {
    const { t } = useTranslator();
    trackPaymentOnboarding(
        'Bank account Onboarding Alert',
        'Will add from - Account menu alert'
    );
    return (
        <div className="alert alert-info d-flex mx-2 my-1 text-hyphenate">
            <InfoIcon className="icon mt-1 mr-2 flex-shrink-0" />
            <span>
                <strong>{t('siteheader_bankAccountMissingTitle')}</strong>
                <br />
                {t('siteheader_bankAccountMissingDescription')}
            </span>
        </div>
    );
};

const PayoutFailedAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex mx-2 my-1 text-hyphenate">
            <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
            <span>
                <strong>{t('siteheader_payoutFailedTitle')}</strong>
                <br />
                {t('siteheader_payoutFailedDescription')}
            </span>
        </div>
    );
};

const PayoutReadyBankAccountMissingAlert = () => {
    const { t } = useTranslator();
    trackPaymentOnboarding(
        'Bank account Onboarding Alert',
        'Will add from - Account menu alert - Failed payment'
    );
    return (
        <div className="alert alert-danger d-flex flex-column mx-2 my-1 text-hyphenate">
            <div className="d-flex">
                <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>
                        {t('siteheader_paymentReadBankAccountMissingTitle')}
                    </strong>
                    <br />
                    {t('siteheader_paymentReadBankAccountMissingDescription')}
                </span>
            </div>
        </div>
    );
};

const HyperwalletPayeeVerificationAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex flex-column mx-2 my-1 text-hyphenate">
            <div className="d-flex mb-1">
                <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>
                        {t('siteheader_hyperwalletPayeeVerificationTitle')}
                    </strong>
                    <br />
                    {t('siteheader_hyperwalletPayeeVerificationDescription')}
                </span>
            </div>
            <Button
                theme="light"
                fluid
                className="mb-1"
                onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/my/PayeeVerification';
                }}>
                {t('siteheader_hyperwalletPayeeVerificationMoreInfo')}
            </Button>
        </div>
    );
};

const HyperwalletPayeeVerificationReviewAlert = () => {
    const { t } = useTranslator();
    return (
        <div
            className="alert alert-info d-flex mx-2 my-1 text-hyphenate"
            onClick={(e) => {
                e.preventDefault();
                window.location.href = '/my/PayeeVerificationCompleted';
            }}>
            <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
            <span>
                <strong>
                    {t('siteheader_hyperwalletPayeeVerificationReviewTitle')}
                </strong>
                <br />
                {t('siteheader_hyperwalletPayeeVerificationReviewDescription')}
            </span>
        </div>
    );
};

const KycQuestionnaireAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-info d-flex flex-column mx-2 my-1 text-hyphenate">
            <div className="d-flex mb-1">
                <InfoIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>{t('siteheader_kycQuestionnaireTitle')}</strong>
                    <br />
                    {t('siteheader_kycQuestionnaireDescription')}
                </span>
            </div>
            <Button
                theme="action"
                variant="outline"
                fluid
                className="mb-1"
                onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/verify/kyc-questionnaire';
                }}>
                {t('siteheader_kycQuestionnaireMoreInfo')}
            </Button>
        </div>
    );
};

const PayoutReadyVerificationRequiredAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex flex-column mx-2 my-1 text-hyphenate">
            <div className="d-flex mb-1">
                <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>
                        {t('siteheader_payoutReadyVerificationRequiredTitle')}
                    </strong>
                    <br />
                    {t('siteheader_payoutReadyVerificationRequiredDescription')}
                </span>
            </div>
        </div>
    );
};

const OutstandingTraderaPayLicenseAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-info d-flex flex-column mx-2 my-1 text-hyphenate">
            <div className="d-flex mb-1">
                <InfoIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>
                        {t('siteheader_outstandingTraderaPayLicenseTitle')}
                    </strong>
                    <br />
                    {t('siteheader_outstandingTraderaPayLicenseDescription')}
                </span>
            </div>
            <Button
                theme="action"
                variant="outline"
                fluid
                className="mb-1"
                onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/my/settings/payouts';
                }}>
                {t('siteheader_outstandingTraderaPayLicenseContinue')}
            </Button>
        </div>
    );
};

const PayoutReadyOutstandingTraderaPayLicenseAlert = () => {
    const { t } = useTranslator();
    return (
        <div className="alert alert-danger d-flex flex-column mx-2 my-1 text-hyphenate">
            <div className="d-flex mb-1">
                <WarningIcon className="icon mt-1 mr-2 flex-shrink-0" />
                <span>
                    <strong>
                        {t(
                            'siteheader_payoutReadyOutstandingTraderaPayLicenseTitle'
                        )}
                    </strong>
                    <br />
                    {t(
                        'siteheader_payoutReadyOutstandingTraderaPayLicenseDescription'
                    )}
                </span>
            </div>
            <Button
                theme="light"
                fluid
                className="mb-1"
                onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/my/settings/payouts';
                }}>
                {t(
                    'siteheader_payoutReadyOutstandingTraderaPayLicenseContinue'
                )}
            </Button>
        </div>
    );
};

export {
    InvoiceUnpaidAlert,
    InvoiceOverdueAlert,
    BankAccountMissingAlert,
    PayoutFailedAlert,
    PayoutReadyBankAccountMissingAlert,
    HyperwalletPayeeVerificationAlert,
    HyperwalletPayeeVerificationReviewAlert,
    KycQuestionnaireAlert,
    PayoutReadyVerificationRequiredAlert,
    OutstandingTraderaPayLicenseAlert,
    PayoutReadyOutstandingTraderaPayLicenseAlert
};
